import React, {useContext, useEffect, useState} from "react";
import {RuoliContext} from "../../context/RuoliContext";
import NsRightClickMenu from "../NsRightClickMenu";

export default function TreeRow({
                                    elemento,
                                    idSelected,
                                    onClickItem,
                                    getLabel,
                                    getFigli,
                                    isFolder,
                                    icona,
                                    initEsploso,
                                    vociClickDestro = [],
                                    classiAggiuntive = (elemento) => '',
                                    startOpen = (elemento) => false,
                                }) {

    const [open, setOpen] = useState(initEsploso);
    const [rigthClicked, setRigthClicked] = useState(false);
    const [points, setPoints] = useState({
        x: 0,
        y: 0,
    });

    const endlerOpen = () => {
        setOpen(!open)
    }

    let figli = getFigli(elemento);

    function contieneSelezionato(figli) {
        let contiene = false;

        if (figli && figli.length > 0) {
            figli.map((item) => {
                if (item.id === idSelected) {
                    contiene = true;
                }
                let selFiglio = contieneSelezionato(getFigli(item))
                if (selFiglio === true) {
                    contiene = true;
                }
            });
        }
        return contiene;
    }

    useEffect(() => {
        if (startOpen && startOpen(elemento) === true) {
            setOpen(true);
        }

        if (idSelected && idSelected !== '') {
            if (contieneSelezionato(figli) === true) {
                setOpen(true);
            }
        }

        const handleClick = () => setRigthClicked(false);
        window.addEventListener("click", handleClick);
        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, []);

    const disegnaIcona = () => {
        if (icona) {
            return icona(elemento)
        } else {
            if (isFolder) {
                return isFolder(elemento) ?
                    open ? <i className="fas fa-folder-open"/>
                        : <i className="fas fa-folder"/>
                    : <i className="fas fa-file-alt"/>
            } else {
                return figli.length > 0 ?
                    open ? <i className="fas fa-folder-open"/>
                        : <i className="fas fa-folder"/>
                    : <i className="fas fa-file-alt"/>
            }
        }
    }

    const isRightClickEnabled = () => {
        return true;
    }

    return <div>
        <NsRightClickMenu
            points={points}
            show={isRightClickEnabled() && vociClickDestro && vociClickDestro.length > 0 && rigthClicked}
            elemento={elemento}
            voci={vociClickDestro}
        />
        <table className={"ns-tree-row-table"}>
            <tbody>
            <tr className={"ns-tree-row"}>
                <td onClick={endlerOpen} className={"ns-tree-row-sign"}>
                    {
                        figli.length > 0 ? !open ? <i className="far fa-plus-square"/> :
                            <i className="far fa-minus-square"/> : ''
                    }
                </td>
                <td
                    className={"ns-tree-row-label " + (elemento.id == idSelected ? 'ns-tree-row-label--selected' : '')}
                    onClick={() => {
                        onClickItem(elemento)
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        setRigthClicked(true);
                        setPoints({
                            x: e.pageX,
                            y: e.pageY - 70,
                        });
                    }}
                >
                    <i className={'ns-tree-row-icon'}>
                    {
                        disegnaIcona()
                    }
                    </i>
                    <span className={classiAggiuntive(elemento)}>
                        {
                            ' '
                        }
                        {
                            getLabel(elemento)
                        }
                    </span>
                </td>
            </tr>
            {
                open && figli.length > 0 ? figli.map((item, index) => {
                    return <tr key={index}>
                        <td/>
                        <td>
                            <TreeRow
                                elemento={item}
                                idSelected={idSelected}
                                onClickItem={onClickItem}
                                getLabel={getLabel}
                                getFigli={getFigli}
                                isFolder={isFolder}
                                initEsploso={initEsploso}
                                icona={icona}
                                vociClickDestro={vociClickDestro}
                                classiAggiuntive={classiAggiuntive}
                                startOpen={startOpen}
                            />
                        </td>
                    </tr>
                }) : ''
            }
            </tbody>
        </table>
    </div>

}